module.exports = __webpack_public_path__ + "static/img/blue-logo.46bd24e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blue-logo.png
// module id = g8LM
// module chunks = 0